import { SbBlokData, storyblokEditable } from '@storyblok/react';

export function patchedStoryblokEditable(blok: SbBlokData): ReturnType<typeof storyblokEditable> {
  if (!blok._editable) {
    return null;
  }

  return storyblokEditable(blok);
}
